import { useAsyncData } from '@redneckz/uni-jsx/lib/hooks/useAsyncData';
import { fetchJSONUnsafe } from '../../utils/fetchJSON.js';
const EXCHANGE_RATES_URL = '/api/v1/exchangerates';
export function useFetchExchangeRateData(currentRegion) {
    const regionCode = currentRegion?.code || '000';
    const { data } = useAsyncData(EXCHANGE_RATES_URL + `?regionCode=${regionCode}`, fetchJSONUnsafe);
    return data || {};
}
//# sourceMappingURL=useFetchExchangeRateData.js.map